import React from "react";

export const SettingsGroupSeparator = () => {
    return (
        <div className="separator separator-dashed my-5"></div>
    )
}